import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { articles } from 'src/app/core/translations/articles';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.scss']
})
export class ArticlesComponent implements OnInit {

  isHandsetPortrait: boolean = false;

  bannerImage: any ='';
  bannerClass: any ='';

  currentLanguage: string = '';
  languageTranslations: any = articles;
  activeLanguageTranslations: any = {};
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private storage: StorageService,
  ) {}

  ngOnInit(): void {

    this.bannerClass = environment.pageClass;
    this.bannerImage = environment.staticPageBanner;

    if (this.route.snapshot.paramMap.get('language')) {
      let language: string | null =
        this.route.snapshot.paramMap.get('language');

      if (language) {

        this.activeLanguageTranslations = this.languageTranslations[language];

        // console.log(this.activeLanguageTranslations);
      }
    }
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }

  repeatArticalCard: any = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'];
  firstDisplayOnlyCards:any = 5;
  viewMoreNtnName: string = 'View More';

  updateCardDisplayLimit(viewMoreNtnName: string) {
    if (viewMoreNtnName === 'View More') {
      this.firstDisplayOnlyCards = this.repeatArticalCard.length - 1;
      this.viewMoreNtnName = 'View Less';
    } else {
      this.firstDisplayOnlyCards = 5;
      this.viewMoreNtnName = 'View More';
    }
  }
  fetchLanguage(): string | null {
    return this.storage.get('language');
  }
  openArticle(article: any): void {
    // Logic to open the article, e.g., navigate to a detailed view
    console.log('Opening article:', article);
    if (this.fetchLanguage() === 'en') {
      this.currentLanguage = 'english';
      this.router.navigate(['/info/english/articlesDetail/', article]);
    // } else if (this.fetchLanguage() === 'panjabi') {
    } else {
      this.currentLanguage = 'panjabi';
      this.router.navigate(['/info/panjabi/articlesDetail/', article]);
    } 
  }
}